<template>
    <div class="row">
        <div class="col-12 mb-1">
            <label class="form-label">Tonaj</label>
            <input type="text" class="form-control" v-model="value.Tonnage" placeholder="Tonaj" />
        </div>
        
    </div>
</template>

<script>
export default {
    props:{
        value:Object
    },
}
</script>

<style>

</style>